export default class Menu {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }

        this.categories = {
            toggler: document.querySelectorAll('.categories-menu li a.nav-link '),
            overlay: document.querySelector('.app-overlay'),
        }

        this.user = {
            toggler: document.getElementById('user'),
        }

        this.minicart = {
            toggler: document.getElementById('cart'),
            main: document.getElementById('minicart'),
        };

        this.lang = {
            toggler: document.querySelector('#select-language .dropdown-toggler'),
            menu: document.querySelector('#select-language .dropdown-menu'),
        }

        this.dropdown = {
            menu: document.querySelectorAll('.dropdown-menu'),
        }

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');
    }

    init() {
        this.toggle();
        this.propagation();
        // if(!Sniff.features.mobile){ this.language(); }
    }

    toggle = () => {
        this.menu.toggler.addEventListener('click', () => {
            this.header.classList.add('menu-active');
            // If Mobile > <body> == overflow:hidden
            if (Sniff.features.mobile) {
                if (this.body.classList.contains('overflow-hidden')) {
                    this.body.classList.remove('overflow-hidden')
                } else {
                    this.body.classList.add('overflow-hidden')
                }
            }

            this.menu.toggler.classList.toggle('active');
            this.menu.main.classList.toggle('active');
            // Search De-activation
            this.search.toggler.classList.remove('active');
            this.search.main.classList.remove('active');
            // Minicart De-activation
            if (this.minicart.toggler) {
                this.minicart.toggler.classList.remove('active');
                this.minicart.main.classList.remove('active');
            }
        });

        this.user.toggler.addEventListener('click', () => {
            // User De-activation
            this.menu.toggler.classList.remove('active');
            this.menu.main.classList.remove('active');
            // Search De-activation
            this.search.toggler.classList.remove('active');
            this.search.main.classList.remove('active');
            // Minicart De-activation
            if (this.minicart.toggler) {
                this.minicart.toggler.classList.remove('active');
                this.minicart.main.classList.remove('active');
            }
        });

        this.categories.toggler.forEach( (element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                var body = document.querySelector('body');
                if (e.target.classList.contains('active')){
                    this.categories.toggler.forEach( (item) => {
                        item.classList.remove('active');
                        item.parentNode.classList.remove('active');
                    })
                    body.classList.remove('active-menu-categories');
                    this.categories.overlay.classList.remove('active-menu-categories');
                } else {
                    this.categories.toggler.forEach( (item) => {
                        item.classList.remove('active');
                        item.parentNode.classList.remove('active');
                    })
                    e.target.classList.add('active');
                    e.target.parentNode.classList.add('active');
                    body.classList.add('active-menu-categories');
                    this.categories.overlay.classList.add('active-menu-categories');
                }
                // var allDropMenu = e.target.parentNode.parentNode.querySelectorAll('.dropdown-menu');
                // allDropMenu.forEach((element) => {
                //     element.classList.remove('show');
                // });
                // var dropmenu = e.target.parentNode.querySelector('.dropdown-menu');
                // dropmenu.classList.toggle('show');

            })
        })

        this.categories.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            var body = document.querySelector('body');
            if (this.categories.overlay.classList.contains('active-menu-categories')){
                this.categories.toggler.forEach( (item) => {
                    item.classList.remove('active');
                    item.parentNode.classList.remove('active');
                })
                body.classList.remove('active-menu-categories');
                this.categories.overlay.classList.remove('active-menu-categories');
            }
        })
    }

    language = () => {
        this.lang.toggler.addEventListener('click', () => {
            this.lang.menu.classList.toggle('show');
        });
    }

    propagation = () => {
        this.dropdown.menu.forEach((menu) => {
            menu.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        })
    }
}
